import { StampCardSorter } from '@models/stamp';
import { atom } from 'jotai';

export const expandStoreStampIdAtom = atom<string>('');

export const logExpandAtom = atom<boolean>(false);

export const stampCardSorterAtom = atom<StampCardSorter>(StampCardSorter.IssuedAtDesc);
